import { BehaviorSubject, generateUUID } from '@mbrtargeting/metatag-utils';

/**
 * A sessionId for beacon deduplication.
 */
export const sessionId$ = new BehaviorSubject(generateUUID());
